import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Box, Button, useIsMounted } from 'seagull';
import { AppleIcon } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import styles from './AppleButton.module.scss';
export const GetAppleSignInButtonTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            AppleSignInButtonTID: {
                Button: 'apple-signin-button'
            }
        }
    });
const BUTTON_HEIGHT = 40;
export function AppleSignInButton(param) {
    let { testId, width, biName, scopes, authenticate, onCredential, onError } = param;
    const { t: authTexts } = useLocaleKeys('auth.screens');
    const { browser: { crypto: { randomNonce } } } = useIoContext();
    const [loading, setLoading] = useState(false);
    const isMounted = useIsMounted();
    const { AppleSignInButtonTID } = useMemo(()=>GetAppleSignInButtonTID(testId), [
        testId
    ]);
    async function handleClick() {
        if (loading) return;
        setLoading(true);
        try {
            const nonce = randomNonce();
            const result = await authenticate({
                nonce,
                scopes
            });
            if (isMounted()) {
                await onCredential(result, nonce);
            }
        } catch (error) {
            if (isMounted()) {
                onError(error);
            }
        } finally{
            if (isMounted()) {
                setLoading(false);
            }
        }
    }
    return /*#__PURE__*/ _jsx(Box, {
        testId: testId,
        className: styles.buttonContainer,
        children: /*#__PURE__*/ _jsx(Button, {
            className: styles.signInButton,
            testId: AppleSignInButtonTID.Button(),
            bi: {
                name: biName
            },
            skin: "blackOutline",
            roundness: "s",
            onClick: handleClick,
            loading: loading,
            prefixIcon: /*#__PURE__*/ _jsx(AppleIcon, {
                size: BUTTON_HEIGHT
            }),
            style: width != null ? {
                width
            } : undefined,
            children: authTexts.continueWithApple()
        })
    });
}
